import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=72c2b2ed&scoped=true&"
import script from "./vertical.vue?vue&type=script&lang=js&"
export * from "./vertical.vue?vue&type=script&lang=js&"
import style0 from "./vertical.vue?vue&type=style&index=0&id=72c2b2ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2b2ed",
  null
  
)

export default component.exports